import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar34Colors = {
  background?: string;
  accessories?: string;
  skin?: string;
  hair?: string;
};

export const Avatar34 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar34Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    accessories: colors.accessories ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar34" clipPath="url(#clip0_2286_5271)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="accessories"
          d="M151.833 303.667c45.084 0 85.573-19.655 113.384-50.866-8.259-12.934-22.284-26.337-45.013-26.576 0 0 27.786-16.438 28.734-41.429.948-24.991-10.719-106.39-31.075-121.952-18.652-14.264-41.477-40.09-64.222-37.734-22.745 2.358-71.556 38.53-68.243 49.377 3.32 10.847 4.006 11.7 4.006 11.7s-19.432 92.421-15.642 104.678c3.791 12.256 14.423 26.321 14.423 26.321s-44.112 18.691-56.25 27.81c27.779 35.702 71.151 58.671 119.89 58.671h.008Z"
          fill={c.accessories}
        />
        <Path
          id="Vector"
          d="M144.212 241.189c3.109 0 5.63-2.799 5.63-6.252 0-3.452-2.521-6.251-5.63-6.251-3.11 0-5.631 2.799-5.631 6.251 0 3.453 2.521 6.252 5.631 6.252Z"
          fill="#fff"
          stroke="#000"
          strokeMiterlimit={10}
        />
        <Path
          id="Vector_2"
          d="M203.91 242.766c3.109 0 5.63-2.799 5.63-6.252 0-3.452-2.521-6.251-5.63-6.251-3.11 0-5.631 2.799-5.631 6.251 0 3.453 2.521 6.252 5.631 6.252Z"
          fill="#fff"
          stroke="#000"
          strokeMiterlimit={10}
        />
        <Path
          id="Vector_3"
          d="M211.507 277.911a3.553 3.553 0 0 1-3.456-2.716c-.032-.135-3.194-13.252-5.87-19.329-3.121-7.103-1.959-18.476-1.815-19.742a3.544 3.544 0 0 1 3.934-3.122c1.951.215 3.361 1.967 3.138 3.91-.327 2.947-.741 11.572 1.258 16.119 2.923 6.65 6.132 19.958 6.268 20.523a3.545 3.545 0 0 1-3.465 4.365l.008-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M103.604 85.39c1.17-14.79-33.322 109.759 34.977 150.264-48.484-42.973-37.685-116.218-34.977-150.264Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_5"
          d="M140.652 241.189c3.528 3.48-37.439-4.81-54.028-24.266 4.922-1.681 23.565 17.783 54.028 24.266Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_6"
          d="M184.932 254.091c8.449-.51 15.76-6.523 23.151-11.946 7.391-5.424 13.467-15.164 13.467-15.164l-2.915.072s-15.259 17.083-33.695 27.046l-.008-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_7"
          d="M144.212 287.19a3.547 3.547 0 0 1-3.472-4.333c.024-.095 2.182-24.784 2.756-32.071.541-6.825-2.637-16.421-2.668-16.517a3.533 3.533 0 0 1 2.253-4.476c1.864-.613 3.879.382 4.5 2.238.151.446 3.663 11.038 3.01 19.313-.621 7.82-2.819 32.7-2.914 33.098a3.554 3.554 0 0 1-3.465 2.748Z"
          fill="#000"
        />
        <Path
          id="Vector_8"
          d="M236.227 117.429c3.736 100.792-36.785 108.653-36.785 108.653s-83.009-8.641-89.969-69.996c-6.841-60.271 29.618-94.978 63.027-95.384 33.018-.399 51.774.852 63.727 56.727Z"
          fill="#000"
        />
        <Path
          id="Vector_9"
          d="M196.081 225.413h.032a19.6 19.6 0 0 1 .111-.685c.2-1.131.526-2.453.908-3.871-.422 1.522-.772 2.947-.987 4.158-.024.127-.04.254-.064.382v.016Z"
          fill="#fff"
          stroke="#000"
          strokeMiterlimit={10}
        />
        <Path
          id="Vector_10"
          d="M199.426 213.49h-.016c-.797 2.366-1.633 4.986-2.286 7.375.661-2.405 1.505-5.033 2.302-7.375Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="skin"
          d="M199.41 213.499c.032-.096.063-.199.095-.295 17.951-3.942 7.009-21.638 23.191-55.963 1.968-13.778.821-13.738.821-30.048 0-24.25-1.227-42.042-7.12-53.884-9.947-13.396-20.467-7.805-41.174-7.566-33.409.398-71.381 24.967-64.548 85.238a68.531 68.531 0 0 0 2.063 10.656c2.723 2.549 5.479 3.656 7.773 2.796.207-.08.398-.176.589-.279l.661 1.226s-.048 6.61-.255 14.025c-.016.43-.024.868-.04 1.306 5.209 7.876 11.827 14.47 19.002 19.974 20.93 16.039 46.574 22.745 55.613 24.72.024-.128.04-.255.064-.382.215-1.211.565-2.637.987-4.158.645-2.381 1.481-5.001 2.286-7.374"
          fill={c.skin}
        />
        <G id="Group" opacity={0.5}>
          <Path
            id="Vector_11"
            d="M194.313 195.341c-4.364.095-6.92-1.872-6.992-1.912-.374-.223-.51-.732-.31-1.138.199-.407.668-.566 1.035-.343.016 0 3.48 1.354 6.212 1.354 2.731 0 5.049-1.601 5.065-1.617.358-.247.828-.127 1.059.263.223.39.12.908-.239 1.155-.087.064-1.473 2.142-5.837 2.23l.007.008Z"
            fill="#2E2017"
          />
        </G>
        <G id="Group_2" opacity={0.5}>
          <Path
            id="Vector_12"
            d="M160.944 169.689c.438-3.281 2.477-4.898 2.524-4.946.239-.246.709-.27 1.044-.055.342.215.422.581.175.828-.008.008-1.617 2.397-1.935 4.444-.319 2.047.82 4.03.828 4.046.175.302.016.645-.358.748-.375.112-.821-.048-.996-.358-.04-.072-1.72-1.434-1.282-4.715v.008Z"
            fill="#2E2017"
          />
        </G>
        <Path
          id="Vector_13"
          d="M213.77 174.252s-8.442 2.461-18.047 2.732c-10.632.302-22.53-1.537-22.426-.271.191 2.413 17.058 8.529 22.681 8.052 7.375-.63 18.19-9.525 17.792-10.521v.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="hair"
          d="M127.121 134.432a40.051 40.051 0 0 1 1.171 3.297c2.158.789 4.786 1.505 4.571.215-4.627-27.953-2.628-40.186 2.413-43.26 5.042-3.074 17.617-18.15 17.617-18.15s4.205 1.17 5.041 5.71c.844 4.54-5.041 9.366-5.041 9.366s4.483.589 11.77-2.78c7.288-3.368 6.021-17.855 6.021-17.855s5.328 1.903 10.091 5.997c4.762 4.101-.144 15.808-.144 15.808s4.627-.294 10.648-3.655c6.021-3.369 3.926-15.514 3.926-15.514s14.925 4.85 17.306 7.924c2.381 3.074 10.489 13.89 11.333 13.308.374-.255.924-1.49 1.401-3.393-10.926-31.935-21.104-29.355-50.682-27.07-30.255 2.342-57.054 15.905-63.417 54.865 5.67.063 12.24 6.052 15.967 15.187h.008Z"
          fill={c.hair}
        />
        <Path
          id="Vector_14"
          d="m121.761 165.388-.661-1.227a4.966 4.966 0 0 1-.589.279c-2.293.86-5.049-.255-7.773-2.795 1.967 7.072 4.978 13.411 8.721 19.081.016-.438.024-.876.04-1.306.215-7.414.255-14.024.255-14.024l.007-.008Z"
          stroke="#000"
          strokeMiterlimit={10}
        />
        <Path
          id="Vector_15"
          d="M204.698 111.329c-.526-.104-1.338.135-2.557.899-5.535 3.481-6.052 13.794-5.917 17.155.136 3.361 9.167 23.725 3.918 28.384-1.632 1.449-6.92-.255-8.784-.255-10.95-.024-8.195 3.265-6.546 3.496 1.648.231 12.846 1.226 14.956 1.011 2.111-.215 5.838-1.505 6.18-5.582.343-4.078-5.272-22.045-5.893-25.485-.136-.765 1.386-2.166 2.286-2.939 1.608-2.071 3.217-6.1 9.007-6.108 6.602 0 12.081 5.575 12.081 5.575v-12.448l-18.739-3.703h.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_16"
          d="M178.863 125.512c-8.473-12.057-26.018-3.632-29.355-.143-.462.485-.558 1.409-.223 2.062.207.391.518.606.836.606.215 0 .43-.096.613-.287.884-.924 2.979-2.27 5.663-3.409 0 .136-.024.263-.024.398 0 3.56 2.763 6.443 6.164 6.443s6.172-2.883 6.172-6.443c0-.876-.175-1.704-.478-2.468 3.465.398 6.762 1.919 9.167 5.336.406.573 1.059.573 1.465 0 .406-.574.406-1.514 0-2.087v-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_17"
          d="M223.278 125.585c-2.452-3.194-15.362-10.919-21.606.135-.294.526-.294 1.386 0 1.911.295.526.781.526 1.083 0 .621-1.099 1.322-1.967 2.079-2.668.048 3.313 2.628 5.981 5.814 5.981 3.185 0 5.813-2.723 5.813-6.076 0-.367-.04-.733-.095-1.083 2.843 1.146 5.168 2.883 6.005 3.974.135.175.294.262.454.262.238 0 .469-.191.613-.549.247-.605.175-1.449-.16-1.895v.008Z"
          fill="#000"
        />
        <Path
          id="Vector_18"
          d="M142.516 117.429s10.823-2.151 20.021-2.151c6.531 0 14.694 1.681 17.744 2.015a2.139 2.139 0 0 0 1.951-.876l1.696-2.294c.932-1.258.375-3.09-1.075-3.559-4.603-1.498-13.586-4.89-19.766-4.365-8.848.749-15.156 1.115-20.571 11.23Z"
          fill="#000"
        />
        <Path
          id="Vector_19"
          d="M200.684 115.94c-.103.884.653 1.616 1.49 1.473 3.392-.597 9.493-1.609 13.156-1.497 4.34.127 10.624.884 10.624.884s.82-6.793-.693-7.908c-1.505-1.115-6.793-1.179-10.879-1.179-4.085 0-6.665.916-8.864 1.903-3.432 1.537-4.603 4.221-4.842 6.332l.008-.008Z"
          fill="#000"
        />
        <G id="Group_3">
          <Path
            id="accessories_2"
            d="M215.673 112.945c-1.681-.183-4.03-.406-7.351-.685-3.249-.278-10.998-.9-13.977-.764-3.193-.414-13.467.199-17.815.493-5.535.375-9.087.677-11.381.924-6.498.04-19.472 3.449-20.714 3.512-2.636.128-33.998 9.223-34.93 11.532-.223.558-.589 5.758.199 5.607.04-.008 29.1-12.026 32.437-12.241a6.446 6.446 0 0 0-.549 2.62c0 14.702 10.695 26.616 23.892 26.616 11.651 0 21.351-9.294 23.462-21.59 1.019-.892 2.373-1.625 4.085-1.625 1.856 0 3.393.844 4.564 1.832 1.831 12.193 9.954 21.391 19.694 21.391 11.094 0 20.086-11.914 20.086-26.616 0-7.741-11.15-11.404-21.702-10.99v-.016Zm-22.658 11.628c-1.401 0-2.62.302-3.687.756.024-.462.032-.932.032-1.402 0-4.467-4.42-7.581-10.576-9.325 6.721-.414 13.347-.669 15.187-.375l.191.032h.199c1.848-.119 6.475.159 11.197.534-4.897 1.784-8.37 4.818-8.37 9.134 0 .534.016 1.068.04 1.601a9.797 9.797 0 0 0-4.213-.955Z"
            fill={c.accessories}
          />
          <Path
            id="Vector_20"
            d="M165.476 148.711c-12.018 0-21.797-11.117-21.797-24.775 0-6.029 10.966-9.191 21.797-9.191 10.831 0 21.798 3.154 21.798 9.191 0 13.666-9.78 24.775-21.798 24.775Z"
            fill="#000"
          />
          <Path
            id="Vector_21"
            d="M217.282 148.711c-9.923 0-17.999-11.117-17.999-24.775 0-6.029 9.055-9.191 17.999-9.191 8.943 0 17.998 3.154 17.998 9.191 0 13.666-8.075 24.775-17.998 24.775Z"
            fill="#000"
          />
        </G>
        <Path
          id="Vector_22"
          d="M132.848 182.94c1.529 4.54 3.966 10.784 7.621 17.752 20.93 16.04 46.574 22.745 55.613 24.72.024-.127.039-.254.063-.382.215-1.21.566-2.636.988-4.157.645-2.381 1.481-5.002 2.286-7.375-39.534 11.803-58.878-20.475-66.563-30.558h-.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5271">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
